var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenrouter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 12) scale(.6 .6) translate(-12 -12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.10913 12.07C3.65512 12.07 5.76627 11.5988 6.85825 10.98C7.95023 10.3612 7.95023 10.3612 10.207 8.75965C13.0642 6.73196 15.0845 7.41088 18.3968 7.41088",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10913 12.07C3.65512 12.07 5.76627 11.5988 6.85825 10.98C7.95023 10.3612 7.95023 10.3612 10.207 8.75965C13.0642 6.73196 15.0845 7.41088 18.3968 7.41088",
    stroke: "currentColor",
    strokeWidth: 3.27593
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6 7.43108L16.0037 10.6622V4.20001L21.6 7.43108Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.0363992
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12.072C3.54599 12.072 5.65714 12.5432 6.74912 13.162C7.8411 13.7808 7.8411 13.7808 10.0978 15.3823C12.9551 17.41 14.9753 16.7311 18.2877 16.7311",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 12.072C3.54599 12.072 5.65714 12.5432 6.74912 13.162C7.8411 13.7808 7.8411 13.7808 10.0978 15.3823C12.9551 17.41 14.9753 16.7311 18.2877 16.7311",
    stroke: "currentColor",
    strokeWidth: 3.27593
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4909 16.7109L15.8945 13.4798V19.942L21.4909 16.7109Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.0363992
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenrouter);
export default __webpack_public_path__ + "static/media/openrouter.8ab53c9baa2f1b3a6ff022314ca6a04f.svg";
export { ForwardRef as ReactComponent };